<template>
  <v-container v-if="access.includes(roles.mforecast)">
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="ShowUpload()"
            >
              Import Data from Excel
            </v-btn>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-progress-linear
            v-if="loading_smscalendar"
            indeterminate
            rounded
            height="6"
          />
          <v-calendar
            ref="calendar"
            v-model="calendar"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showSMSDataEvent"
            @click:date="showSMSData"
            @change="updateRange"
          />
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
            >
              <v-toolbar
                :color="selectedEvent.color"
                dark
              >
                <v-btn icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-toolbar-title v-html="selectedEvent.name" />
                <v-spacer />
                <v-btn icon>
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <span v-html="selectedEvent.details" />
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="secondary"
                  @click="selectedOpen = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <!-- Show Editor dialog -->
    <v-dialog
      v-model="showEditor"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <v-toolbar>
          <h2 class="primary--text">
            Hourly Sales
          </h2>
          <v-spacer />
          <v-btn
            v-if="access.includes(roles.mforecast_update)"
            color="green darken-1"
            text
            loading
            :class="{hidden: !saving }"
          />
          <v-btn
            v-if="access.includes(roles.mforecast_update)"
            color="green darken-1"
            text
            :class="{hidden: !saving }"
          >
            Auto Saving Data ...
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="saving"
            :class="{hidden: saving }"
            @click="showEditor = false, GetSMSCalendar()"
          >
            Close
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          v-if="loading_smsdata"
          indeterminate
          rounded
          height="6"
        />
        <v-card-text>
          <vue-excel-editor
            v-if="!loading_smsdata"
            v-model="smsdata"
            :no-paging="true"
            :no-finding="true"
            :disable-panel-filter="true"
            :hidden="loading_smsdata"
            @update="onUpdate"
          >
            <template v-for="(item, i) in headers_smsdata">
              <vue-excel-column
                :key="`column-${i}`"
                :field="item.value"
                :label="item.text"
                :type="item.type"
                :readonly="item.readonly || !access.includes(roles.mforecast_update)"
                :validate="validNumber"
              />
            </template>
          </vue-excel-editor>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End showEditor dialog -->

    <!-- Upload file dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_upload"
          width="50%"
          max-width="50%"
        >
          <v-card>
            <v-card-title class="text-left">
              <v-row>
                <h2 class="primary--text">
                  Import Manager Forecast Data
                </h2>
              </v-row>
            </v-card-title>
            <v-card-text>
              <template>
                <v-file-input
                  v-model="excel_file"
                  show-size
                  label="Click here to browse your file"
                  accept=".xlsx"
                />
              </template>
              <v-btn
                color="green darken-1"
                text
                plain
                style="text-decoration: underline;opacity:1;"
                :disabled="in_process"
                href="https://escheduling.mcd.com.ph/manager_forecast_template.xlsx"
                target="_blank"
                download
              >
                Download template
              </v-btn>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                :disabled="in_process"
                @click="UploadFile()"
              >
                Upload
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :disabled="in_process"
                @click="show_upload = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- End upload file dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import moment from 'moment'
  import {
    GetSalesProjection,
    GetSMSCalendar,
    UpdateSalesProjection,
  } from '@/graphql/SalesProjection.gql'
  import {
    UploadFile,
  } from '@/graphql/File.gql'
  import {
    mapState,
  } from 'vuex'

  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data: () => ({
      // rebuild
      calendar: '',
      type: 'month',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      smsdata: [],
      smscalendar: [],
      headers_smsdata: [
        { text: 'Date', value: 'HSPDAY', readonly: true },
        { text: 'Time', value: 'HSPTIM', readonly: true },
        { text: 'Gross Sales', value: 'HSPSAG', readonly: true },
        { text: 'Guest Count', value: 'HSPTAC', readonly: true },
        { text: 'PRD Sales', value: 'HSPSAG', readonly: true },
        { text: 'PRD Count', value: 'HSPTAC', readonly: true },
        { text: 'IR Sales', value: 'HSPSFC', readonly: false, type: 'number', is_count: false },
        { text: 'IR Guest Count', value: 'HSPTFC', readonly: false, type: 'number', is_count: true },
        { text: 'DT Sales', value: 'HSPSDT', readonly: false, type: 'number', is_count: false },
        { text: 'DT Guest Count', value: 'HSPTDT', readonly: false, type: 'number', is_count: true },
        { text: 'MDS Sales', value: 'HSPSDS', readonly: false, type: 'number', is_count: false },
        { text: 'MDS Guest Count', value: 'HSPTDS', readonly: false, type: 'number', is_count: true },
        { text: 'McCAFE Sales', value: 'HSPSCF', readonly: false, type: 'number', is_count: false },
        { text: 'McCAFE Guest Count', value: 'HSPTCF', readonly: false, type: 'number', is_count: true },
        { text: 'DC Sales', value: 'HSPSCO', readonly: false, type: 'number', is_count: false },
        { text: 'DC Guest Count', value: 'HSPTCO', readonly: false, type: 'number', is_count: true },
      ],
      loading_smsdata: false,
      skip_smsdata: true,
      loading_smscalendar: false,
      skip_smscalendar: true,
      showEditor: false,
      start: '',
      end: '',
      smsdata_hash: '',
      saving: false,
      show_upload: false,
      excel_file: null,
    }),
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
    },
    mounted () {
      window.scrollTo(0, 0)
      if (this.$refs.calendar) this.$refs.calendar.checkChange()
    },
    methods: {
      ShowUpload () {
        if (!this.access.includes(this.roles.mforecast_import)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_upload = true
      },
      onUpdate (item) {
        if (isNaN(item[0].newVal)) return
        if (Number(item[0].newVal) < 0) return
        var i = this.smsdata.find(x => x.$id === item[0].$id)
        i.HSPSAG = 0
        i.HSPTAC = 0
        this.headers_smsdata.forEach(function (val) {
          if (!val.readonly) {
            if (!isNaN(i[val.value])) {
              if (val.is_count) {
                i.HSPTAC += parseInt(i[val.value])
              } else {
                i.HSPSAG += parseInt(i[val.value])
              }
            }
          }
        })
        this.$store.commit('Notify', '')
        this.SaveSMSData([i])
        this.$store.commit('CloseAlert', '')
      },
      SaveSMSData (d = null) {
        if (!this.access.includes(this.roles.mforecast_update)) {
          return
        }
        if (d == null) { d = this.smsdata }
        this.saving = true
        this.$apollo.mutate({
          mutation: UpdateSalesProjection,
          variables: {
            hash: this.smsdata_hash,
            data: JSON.stringify(d),
          },
        }).then((res) => {
          if (res.data.UpdateSalesProjection.status === 'Ok') {
          } else if (res.data.UpdateSalesProjection.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateSalesProjection.status)
          }
          this.saving = false
        }).catch(error => {
          this.CheckError(error)
        })
      },
      UploadFile () {
        const managerforecast = 200
        if (!this.excel_file) {
          this.$store.commit('ShowError', 'Please select file to upload.')
          return
        }
        this.$store.commit('Notify', 'Uploading file...')
        this.$apollo.mutate({
          mutation: UploadFile,
          variables: {
            file: this.excel_file,
            type: managerforecast,
          },
        }).then((res) => {
          if (res.data.UploadFile.status === 'Ok') {
            this.$store.commit('CloseAlert', '')
            this.show_upload = false
            this.GetSMSCalendar()
            this.excel_file = null
          } else if (res.data.UploadFile.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UploadFile.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      showSMSData () {
        this.smsdata = []
        this.loading_smsdata = true
        this.skip_smsdata = false
        this.$apollo.queries.GetSalesProjection.refetch()
        this.showEditor = true
      },
      showSMSDataEvent ({ nativeEvent, event }) {
        this.calendar = event.start
        this.showSMSData()
      },
      validNumber (content, oldContent, record, field) {
        if (content === '') return ''
        if (isNaN(content)) return 'Invalid Value'
        if (Number(content) < 0) return 'Invalid Value'
        return '' // return empty string if there is no error
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.calendar = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      updateRange ({ start, end }) {
        this.start = start.date
        this.end = end.date
        this.GetSMSCalendar()
      },
      GetSMSCalendar () {
        this.events = []
        this.smscalendar = []
        this.loading_smscalendar = true
        this.skip_smscalendar = false
        this.$apollo.queries.GetSMSCalendar.refetch()
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      FormatTime (t) {
        return moment(t, 'HHmm').format('HH:mm')
      },
    },
    apollo: {
      GetSalesProjection: {
        error (error) {
          this.loading_smsdata = false
          this.CheckError(error)
        },
        query: GetSalesProjection,
        variables () {
          return {
            date: this.calendar,
          }
        },
        skip () {
          return this.skip_smsdata
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetSalesProjection) {
              if (data.GetSalesProjection.status === 'Ok') {
                this.smsdata = data.GetSalesProjection.data
                this.smsdata_hash = data.GetSalesProjection.hash
                for (const index in this.smsdata) {
                  var i = this.smsdata[index]
                  i.HSPSAG = 0
                  i.HSPTAC = 0
                  i.HSPTIM = this.FormatTime('0000'.substring(0, 4 - i.HSPTIM.length) + i.HSPTIM)
                  this.headers_smsdata.forEach(function (val) {
                    if (!val.readonly) {
                      if (!isNaN(i[val.value])) {
                        if (val.is_count) {
                          i.HSPTAC += parseInt(i[val.value])
                        } else {
                          i.HSPSAG += parseInt(i[val.value])
                        }
                      }
                    }
                  })
                }
              } else if (data.GetSalesProjection.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              }
              this.loading_smsdata = false
              this.skip_smsdata = true
            }
          }
        },
      },
      GetSMSCalendar: {
        error (error) {
          this.loading_smscalendar = false
          this.CheckError(error)
        },
        query: GetSMSCalendar,
        variables () {
          return {
            start: this.start,
            end: this.end,
          }
        },
        skip () {
          return this.skip_smscalendar
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetSMSCalendar) {
              if (data.GetSMSCalendar.status === 'Ok') {
                this.smscalendar = data.GetSMSCalendar.data
                for (const index in this.smscalendar) {
                  this.events.push({
                    name: this.smscalendar[index].count < 24 ? 'Incomplete' : this.smscalendar[index].sales_hours < 8 ? 'Partial' : 'Updated',
                    start: this.smscalendar[index].date,
                    end: this.smscalendar[index].date,
                    color: this.smscalendar[index].count < 24 ? 'red' : this.smscalendar[index].sales_hours < 8 ? 'orange' : 'cyan',
                  })
                }
              } else if (data.GetSMSCalendar.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              }
              this.loading_smscalendar = false
              this.skip_smscalendar = true
            }
          }
        },
      },
    },
  }
</script>
